'use client';

import { memo, useEffect, useMemo, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import gsap from 'gsap/all';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Text, Container, Icon, api, useResizeObserver, Image, Link } from '@weareconceptstudio/core';

//* Styles
import SliderInstagramStyle from './style';

const SliderInstagram = memo(() => {
	const [data, setData] = useState([]);

	//! Ref
	const swiperRef = useRef();
	const scrollTriggerRef = useRef();
	const resize = useResizeObserver(typeof document !== 'undefined' ? document.querySelector('body') : null);

	//! Animation
	useEffect(() => {
		if (data.length) {
			const itemSlider = swiperRef.current.children[0].children;
			const firstSeeChildren = [...itemSlider].slice(0, 4);

			scrollTriggerRef.current = ScrollTrigger.create({
				start: 'center bottom',
				end: 'center bottom',
				// markers: true,
				trigger: swiperRef.current,

				onEnter: () => {
					firstSeeChildren.map((item, i) => {
						gsap.to(item, {
							y: 0,
							duration: `${i % 2 ? 1 : 0.9}`,
							ease: 'power2.out',
							delay: `${i % 2 ? 0.05 : 0}`,
						});
					});
				},
			});
		}

		return () => {
			if (scrollTriggerRef.current) scrollTriggerRef.current.kill();
		};
	}, [data, resize]);

	useEffect(() => {
		api.get({ url: 'instagram-feed' }).then((res) => {
			setData(res);
		});
	}, []);

	const itemSlide = useMemo(() => {
		return data.map((item, i) => {
			return (
				<SwiperSlide key={i}>
					<Link
						external
						url={item.permalink}>
						<div className='wrapper-image'>
							<div className='wrapper-title'>
								<Text
									external
									url={item.permalink}
									className={'instagram-button instagram p4 font-montserrat-arm-medium'}>
									@MURAKAMI_CITY
								</Text>
							</div>
							<Image src={item.media_type == 'VIDEO' ? item.thumbnail_url : item.media_url} />
						</div>
					</Link>
				</SwiperSlide>
			);
		});
	}, [data]);

	return data?.length > 0 ? (
		<SliderInstagramStyle>
			<Container isSection>
				<div className='top-block'>
					<Text
						tag={'h2'}
						className={'h2 uppercase'}
						text={'instagramInfo'}
					/>

					<div className='slider-icons-blok'>
						<Icon
							name={`left-arrow`}
							className={'swiper-button-prev-instagram slider-icon'}
						/>

						<Icon
							name={`right-arrow`}
							className={`swiper-button-next-instagram slider-icon`}
						/>
					</div>
				</div>
				<div className={'slider-block'}>
					<div className='empty left-empty' />
					<Swiper
						ref={swiperRef}
						slidesPerView={'auto'}
						modules={[Navigation]}
						navigation={{
							prevEl: '.swiper-button-prev-instagram',
							nextEl: '.swiper-button-next-instagram',
						}}>
						{itemSlide}
					</Swiper>
					<div className='empty right-empty' />
				</div>
			</Container>
		</SliderInstagramStyle>
	) : null;
});

export default SliderInstagram;
